import Icon from '../../components/Icon';

// Small pieces shared by the סטטיסטיקות tabs (StatsPage.jsx, SuppliersView.jsx),
// so the tabs format, label and sort the same way.

const nf = new Intl.NumberFormat('he-IL');
export const fmt = (n) => nf.format(n || 0);
export const pct = (n, total) => (total ? Math.round((n / total) * 1000) / 10 : 0);

export const Dash = () => <span className="cc-muted">—</span>;

export function Metric({ label, value, detail, tone }) {
  return (
    <div className={`cc-metric${tone ? ` is-${tone}` : ''}`}>
      <span className="cc-metric-value">{value}</span>
      <span className="cc-metric-label">{label}</span>
      {detail && <span className="cc-metric-detail">{detail}</span>}
    </div>
  );
}

// Column header that sorts its table by itself, largest first. A second click
// on the active column does nothing new — "largest first" is the only order a
// prioritisation screen needs, and a toggle would just be a way to get lost.
// `ascending` is for the one list that does flip (לטיפול → מחוקים, by date).
export function SortTh({ col, sort, onSort, children, className, ascending = false }) {
  const active = sort === col;
  const activeSort = ascending ? 'ascending' : 'descending';
  return (
    <th aria-sort={active ? activeSort : 'none'} className={className}>
      <button type="button" className={`cc-sortbtn${active ? ' is-active' : ''}`} onClick={() => onSort(col)}>
        {children}
        {active && <Icon name="chevron" size={12} style={ascending ? { transform: 'rotate(180deg)' } : undefined} />}
      </button>
    </th>
  );
}
